/**
 * FuelCompanyIcon - Visar logotyp för bränslebolag
 */

import React from 'react';

interface FuelCompanyIconProps {
  companyName: string;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  className?: string;
}

// Mappning från företagsnamn till logo-fil
const logoMap: Record<string, string> = {
  'OKQ8': '/images/fuel-companies/okq8.svg',
  'okq8': '/images/fuel-companies/okq8.svg',
  'Circle K': '/images/fuel-companies/circlek.svg',
  'circlek': '/images/fuel-companies/circlek.svg',
  'circle k': '/images/fuel-companies/circlek.svg',
  'Preem': '/images/fuel-companies/preem.svg',
  'preem': '/images/fuel-companies/preem.svg',
  'Shell': '/images/fuel-companies/shell.svg',
  'shell': '/images/fuel-companies/shell.svg',
  'St1': '/images/fuel-companies/st1.svg',
  'st1': '/images/fuel-companies/st1.svg',
  'ST1': '/images/fuel-companies/st1.svg',
  'Tanka': '/images/fuel-companies/tanka.svg',
  'tanka': '/images/fuel-companies/tanka.svg',
  'Ingo': '/images/fuel-companies/ingo.svg',
  'ingo': '/images/fuel-companies/ingo.svg',
  'Qstar/Bilisten/Pump': '/images/fuel-companies/qstar-bilisten-pump.svg',
  'Din-X': '/images/fuel-companies/din-x.svg',
  'din-x': '/images/fuel-companies/din-x.svg',
  'Svensk Biogas': '/images/fuel-companies/svensk-biogas.svg',
  'svensk biogas': '/images/fuel-companies/svensk-biogas.svg',
  'Energifabriken': '/images/fuel-companies/energifabriken.svg',
  'energifabriken': '/images/fuel-companies/energifabriken.svg',
  'Fundins': '/images/fuel-companies/fundins.svg',
  'fundins': '/images/fuel-companies/fundins.svg',
  'Paroy': '/images/fuel-companies/paroy.svg',
  'paroy': '/images/fuel-companies/paroy.svg',
};

// Storlekar i pixlar
const sizeMap = {
  sm: 24,
  md: 32,
  lg: 48,
};

const FuelCompanyIcon: React.FC<FuelCompanyIconProps> = ({
  companyName,
  size = 'md',
  showName = false,
  className = '',
}) => {
  const logoUrl = logoMap[companyName] || logoMap[companyName.toLowerCase()];
  const pixelSize = sizeMap[size];

  if (!logoUrl) {
    // Fallback - visa första bokstaven i en cirkel
    return (
      <div className={`inline-flex items-center gap-2 ${className}`}>
        <div
          className="bg-gray-400 text-white font-bold flex items-center justify-center rounded"
          style={{ width: pixelSize, height: pixelSize, fontSize: pixelSize * 0.4 }}
        >
          {companyName.charAt(0).toUpperCase()}
        </div>
        {showName && <span className="text-sm font-medium">{companyName}</span>}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={logoUrl}
        alt={companyName}
        style={{ width: pixelSize, height: pixelSize }}
        className="rounded"
      />
      {showName && <span className="text-sm font-medium">{companyName}</span>}
    </div>
  );
};

export default FuelCompanyIcon;

// Exportera även listan av tillgängliga företag
export const fuelCompanies = [
  { id: 1, name: 'OKQ8', logo: '/images/fuel-companies/okq8.svg' },
  { id: 2, name: 'Circle K', logo: '/images/fuel-companies/circlek.svg' },
  { id: 3, name: 'Preem', logo: '/images/fuel-companies/preem.svg' },
  { id: 4, name: 'Shell', logo: '/images/fuel-companies/shell.svg' },
  { id: 5, name: 'St1', logo: '/images/fuel-companies/st1.svg' },
  { id: 6, name: 'Tanka', logo: '/images/fuel-companies/tanka.svg' },
  { id: 7, name: 'Ingo', logo: '/images/fuel-companies/ingo.svg' },
];
